import React, { useEffect, useState } from "react"
import { AvForm, AvField, AvCheckboxGroup, AvCheckbox, AvRadioGroup, AvRadio } from "availity-reactstrap-validation"
import store from "store";

import { ReactComponent as Warning } from 'assets/images/svg/warning.svg';
import { ReactComponent as Download } from 'assets/images/svg/download.svg';
import { ReactComponent as Delete } from 'assets/images/svg/delete.svg';

class Collection extends React.PureComponent {

    constructor(props) {
        super(props);        
        this.state = {
            collectionSector : '',
            handlingItem : '',
            employees : '',
            vehicles : [],
            special5 : '',
            cargo35 : '',
            cargo12 : '',
            performance : [],
            businessPartners : '',
            inputText: '',
            previous: '',
            current: '',
            monthlycurrent: '',
            businessPartnersFile: []
        }
        const code = store.getState().Data?.code[0] || []
        this.collectionSectors = code.filter(item => item.code === 'collectionSectors')
        this.handlingItems = code.filter(item => item.code === 'handlingItems')
        this.employees = code.filter(item => item.code === 'employees')
        this.vehicles = code.filter(item => item.code === 'vehicles')
        this.performances = code.filter(item => item.code === 'performances')
        this.businessPartners = code.filter(item => item.code === 'businessPartners')
    }

    isValiddate = () => {  
        
        if(this.state.sector === ''){
            alert("업종을 선택 해주세요.")
            return("")
        }

        if(this.state.handlingItem === ''){
            alert("취급품목을 선택해주세요.")
            return("")
        }

        if(this.state.employees === ''){
            alert("종업원수를 선택해주세요.")
            return("")
        }

        for(let i=0; i<this.state.vehicles.length; i++){
            const item = this.state.vehicles[i];
            if(this.state[item] === ''){
                alert("보유차량 수를 입력해주세요.")
                return("")
            }
        }
        
        for(let i=0; i<this.state.performance.length; i++){
            const item = this.state.performance[i];
            if(this.state[item] === ''){
                alert("처리실적을 입력해주세요.")
                return("")
            }
        }

        return "success"
    }

    ifVehiclesUnchecked = (e) => {
        this.setState({vehicles : this.state.vehicles.filter(item => item !== e.target.id), [e.target.id] : ''})                          
    }

    ifPerformancesUnchecked = (e) => {
        this.setState({performance : this.state.performance.filter(item => item !== e.target.id), [e.target.id] : ''})                          
    }

    registFiles = (e) => {
        this.setState({businessPartnersFile : [...e.target.files]})
    }

    deleteFile = () => {
        this.setState({businessPartnersFile : []})
    }

    fileDownload = async (str) => {
        let url = `https://waveradmin.ropiklabs.com/media/sample/${str}.xlsx`
        fetch(url)
            .then((response) => response.blob())
            .then((blob) => {
                const excelUrl = window.URL.createObjectURL(new Blob([blob]));
                const link = document.createElement('a');
                link.href = excelUrl;
                link.setAttribute('download', `${str}.xlsx`);
                document.body.appendChild(link);
                link.click();
            })
            .catch((error) => {
                console.error(error)
            })
    };

    render() {
        return (
        <>
            <div className="mb-4">
                <p className="noMargin text-black font-weight-bold font-size-16">업종선택</p>
                {this.collectionSectors && this.collectionSectors.map((item, index) => { return (
                    <div className="form-check form-check-inline mt-2" key={item.key+'_'+index}>
                        <input className="is-untouched is-pristine av-valid form-check-input" type='radio' id={item.key} name="collectionSector" value={item.key} onChange={()=>{this.setState({collectionSector : item.key})}} />
                        <label className="noMargin form-check-label font-size-16 text-black" htmlFor={item.key} >{item.text}</label>
                    </div>
                )})
                }
            </div>

            <div className="mb-4">
                <p className="noMargin text-black font-weight-bold font-size-16">취급품목</p>
                {this.handlingItems && this.handlingItems.map((item, index) => { return (
                    <div className="form-check form-check-inline mt-2" key={item.key+'_'+index}>
                        <input className="is-untouched is-pristine av-valid form-check-input" type='radio' id={item.key} name="handlingItems" value={item.key} onChange={()=>{this.setState({handlingItem : item.key})}} />
                        <label className="noMargin form-check-label font-size-16 text-black" htmlFor={item.key} >{item.text}</label>
                    </div>
                )})
                }
            </div>

            <div className="mb-4">
                <p className="noMargin text-black font-weight-bold font-size-16">종업원 수</p>
                {this.employees && this.employees.map((item, index) => { return (
                    <div className="form-check form-check-inline mt-2" key={item.key+'_'+index}>
                        <input className="is-untouched is-pristine av-valid form-check-input" type='radio' id={item.key} name="employees" value={item.key} onChange={()=>{this.setState({employees : item.key})}} />
                        <label className="noMargin form-check-label font-size-16 text-black" htmlFor={item.key} >{item.text}</label>
                    </div>
                )})
                }
            </div>

            <div className="mb-4">
                <p className="noMargin text-black font-weight-bold font-size-16">보유차량 수</p>
                {this.vehicles && this.vehicles.map((item, index) => { return (
                    <div className="form-check form-check-inline mt-2 d-flex align-items-center" key={item.key + '_' + index}>
                        <input className="is-untouched is-pristine av-valid form-check-input" type='checkbox' id={item.key} name="vehicles" value={item.key}
                        onChange={(e)=>{
                            e.target.checked ? this.setState({vehicles : [ ...this.state.vehicles, item.key]}) : this.ifVehiclesUnchecked(e)
                        }}
                        />
                        <label className="form-check-label font-size-16 text-black margin-left-8" htmlFor={item.key}>{item.text + ' - '}</label>
                        <input className="is-touched is-dirty av-valid form-control font-size-16 margin-left-6 margin-right-6 input-text-right number-input" value={this.state[item.key]}  disabled={this.state.vehicles.indexOf(item.key) > -1 ? false : "disabled"} onChange={(e)=>{
                            this.setState({[item.key] : e.target.value})
                        }}/>
                        <p className="noMargin form-check-label font-size-16 text-black">대</p>
                    </div>
                )})
                }
            </div>

            <div className="mb-4">
                <p className="noMargin text-black font-weight-bold font-size-16">처리실적</p>
                {this.performances && this.performances.map((item, index) => { return (
                    <div className="form-check form-check-inline mt-2 d-flex align-items-center" key={item.key + '_' + index}>
                        <input className="is-untouched is-pristine av-valid form-check-input"  type='checkbox' id={item.key} name="performances" value={item.key}
                        onChange={(e)=>{
                            e.target.checked ? this.setState({performance : [ ...this.state.performance, item.key]}) : this.ifPerformancesUnchecked(e)
                        }}
                        />
                        <label className="form-check-label font-size-16 text-black margin-left-8" htmlFor={item.key}>{item.text + ' - '}</label>
                        <input className="is-touched is-dirty av-valid form-control font-size-16 margin-left-6 margin-right-6 input-text-right number-input" value={this.state[item.key]} disabled={this.state.performance.indexOf(item.key) > -1 ? false : "disabled"} onChange={(e)=>{
                            this.setState({[item.key] : e.target.value})
                        }}/>
                        <p className="noMargin form-check-label font-size-16 text-black">Ton</p>
                    </div>
                )})
                }
            </div>

            <div className="mb-4">
                <p className="noMargin text-black font-weight-bold font-size-16">거래처 수</p>
                {this.businessPartners && this.businessPartners.map((item, index) => { return (
                    <div className="form-check form-check-inline mt-2" key={item.key+'_'+index}>
                        <input className="is-untouched is-pristine av-valid form-check-input" type='radio' id={item.key} name="businessPartners" value={item.key} onChange={()=>{this.setState({businessPartners : item.key})}} />
                        <label className="noMargin form-check-label font-size-16 text-black" htmlFor={item.key} >{item.text}</label>
                    </div>
                )})
                }
            </div>

            {/* <div className="mb-4">
                <p className="noMargin text-black font-weight-bold font-size-16">거래처 리스트 업로드</p>
                    <div className="download-container mt-2 d-flex flex-column justify-content-between" style={{height: 'fit-content'}}>
                        <div className="d-flex align-items-top">
                            <Warning width={28} height={22} />
                            <p className="noMargin font-size-14 text-black padding-left-8">거래처명/대표자명/주소/연락처/올바로등록대상업체 여부 포함 필수</p>
                        </div>
                        <div className="waver-pagination-btn-group float-right d-flex justify-content-end">
                            <button className="waves-effect submit-btn btn btn-secondary font-size-14 mt-2"
                            onClick={() => {
                                this.fileDownload('거래처등록엑셀')
                            }}
                            >샘플 엑셀파일 다운로드<Download className="margin-left-8" />
                            </button>
                        </div>
                    </div>
                <label className="waves-effect waves-light btn btn-primary font-size-16 margin-top-16" htmlFor="ex_file">파일 선택</label>
                <input style={{display: "none"}} type="file" accept=".xls,.xlsx" id="ex_file" onChange={(e)=>{
                    this.registFiles(e)
                }}/>
                {this.state.businessPartnersFile?.length > 0 && this.state.businessPartnersFile.map((item, index) => {
                return (
                    <div className="file-confirm" key={index}>
                        <p className="noMargin">{item.name}</p>
                        <Delete className="margin-left-8 pointer" onClick={()=>{this.deleteFile()}} />
                    </div>
                )
                })
                }
            </div> */}

            <div className="">
                <div className="col-12 text-end">
                    <button
                        className="btn btn-primary w-md waves-effect waves-light mt-5 w-100 font-size-16"
                        type="submit"
                        onClick={() => {
                            if (this.isValiddate() === 'success') {
                                this.props.handlePress({
                                    ...this.state
                                })
                            }
                        }}
                    >
                        회원가입 완료하기
                    </button>
                </div>
            </div>
        </>
        );
    }
};

export default Collection;